import { render, staticRenderFns } from "./RatesTable.vue?vue&type=template&id=2285dc94&scoped=true&"
import script from "./RatesTable.vue?vue&type=script&lang=js&"
export * from "./RatesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285dc94",
  null
  
)

export default component.exports